<template>
  <div class="index">
    <div class="index-top">
      <header-nav />
      <h1 class="index-title">
        江都区无形资产大数据可视化平台
      </h1>
      <div class="charts-container">
        <charts />
      </div>   
      <div class="footer">
        <div>
          主办单位（版权所有）：扬州市江都区无形资产发展战略工作领导小组办公室
          <span>技术支持：<a href="https://www.baiten.cn/">江苏佰腾科技有限公司</a></span>
        </div>
        <div class="flex_row_center">   
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32108802010614" 
            class="footer_href flex_row_center"
          >
            <img src="@/assets/images/nationFlag.png">
            <p>苏公网安备 32108802010614号</p>
          </a>     
          <span>苏ICP备05003075号-6</span>
          <span>
            建议使用1920*1080分辨率
            IE9.0版本以上浏览器
          </span>
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import charts from "@/components/charts/charts";
import HeaderNav from "@/components/header/header";

import "./index.css";
export default {  
  components:{
    charts,
    HeaderNav
  }
}
</script>